var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center text-gray-600"},[_c('i',{staticClass:"uil uil-cog lg-cog"}),_c('h1',{staticClass:"-mt-10 mb-10"},[_vm._v("Select an Option")])])])
}]

export { render, staticRenderFns }